import React, { FunctionComponent } from 'react';

import { Icon, Text, Button } from '../Primitives';
import ReviewStar from '../UILegacy/ReviewStar';

import DummyImg from '../../assets/dummy-img.png';

import { IVenue } from '../../interface/Venue';
import { useHistory } from 'react-router-dom';
import { useStores } from '../../hooks/useStore';

type Props = {
  venue: IVenue;
};

const VenueCard: FunctionComponent<Props> = ({ venue }) => {
  const { venueStore } = useStores();
  const { getSelectedVenue } = venueStore;

  const {
    venueName,
    media,
    location: { address },
    reviewSummary: { overallStars, reviewsNumber },
    facilityGroups,
    pageInfo,
    canCallToBook,
    phoneNumber,
  } = venue;

  const onlineBookingEnabled = facilityGroups.some(
    (f) => f.onlineBookingEnabled
  );

  const firstImage = media.length && media[0].url;

  const history = useHistory();

  const onClickVenue = (event: React.MouseEvent) => {
    event.stopPropagation();
    history.push(`/venues/${pageInfo.uri}`);
    getSelectedVenue(pageInfo.uri);
  };

  const onClickBooking = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!onlineBookingEnabled) return;
    history.push(`/venues/${pageInfo.uri}?booking=true`);
  };

  return (
    <div 
      className="bg-white rounded-lg shadow-sm border border-border overflow-hidden cursor-pointer hover:shadow-md transition-shadow"
      onClick={onClickVenue}
    >
      <div
        className="w-full h-[140px] bg-no-repeat bg-cover bg-center rounded-t-lg"
        style={{ backgroundImage: `url(${firstImage || DummyImg})` }}
      />
      <div className="p-3">
        <Text truncate variant="lb.lg">
          {venueName}
        </Text>
        <ReviewStar
          isShowTotal
          overallStars={overallStars}
          reviewsNumber={reviewsNumber}
        />
        <div className="flex items-center mt-3">
          <div className="min-w-5 flex items-center">
            <Icon icon="location" />
          </div>
          <Text
            className="flex-1"
            truncate
          >
            {address}
          </Text>
        </div>
      </div>
      <div className="flex justify-center px-3 pb-3">
        <Button
          fullWidth
          variant="outline"
          onClick={onClickBooking}
        >
          {onlineBookingEnabled ? (
            'Book instantly'
          ) : canCallToBook && phoneNumber ? (
            <a href={`tel:${phoneNumber}`}>Call to book</a>
          ) : (
            'View'
          )}
        </Button>
      </div>
    </div>
  );
};

export default VenueCard;
